import { render, staticRenderFns } from "./Juhe.vue?vue&type=template&id=58a680b8&scoped=true"
import script from "./Juhe.vue?vue&type=script&lang=ts"
export * from "./Juhe.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Juhe.vue?vue&type=style&index=0&id=58a680b8&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "58a680b8",
  "0dfd4737"
  
)

export default component.exports